import { format } from 'date-fns';
import moment from 'moment';
const monthArr = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const getDate = (date) => {
    const d = new Date(date);
    const dt = d.getDate();
    return dt < 10 ? '0' + dt : dt;
};

export const getDateInSlashFormat = (date) => {
    const dateTimeArr = date.split('T');
    const dateArr = dateTimeArr[0].split('-');
    return dateArr[1] + '/' + dateArr[2] + '/' + dateArr[0];
};

export const getMonth = (date) => {
    const d = new Date(date);
    const m = d.getMonth();
    return (m >= 9 ? m + 1 : '0' + (m + 1)).toString();
};

export const getMonthName = (date) => {
    const d = new Date(date);
    const m = d.getMonth();
    return convertMonthName(Number(m + 1));
};

/* Date functions not used as of now
export const getTime = date => {
    const d = new Date(date);
    return d.toTimeString();
};

export const getTimeInAMPMWithSeconds = date => {
    const timeArr = getTime(date).split(':');
    const postFix = Number(timeArr[0]) >= 12 ? 'PM' : 'AM';
    const hr = convertTo12HrFormat(timeArr[0]);
    return hr + ':' + timeArr[1] + ':' + timeArr[2] + ' ' + postFix;
};

export const getTimeInAMPMWithoutSeconds = date => {
    const timeArr = getTime(date).split(':');
    const postFix = Number(timeArr[0]) >= 12 ? 'PM' : 'AM';
    const hr = convertTo12HrFormat(timeArr[0]);
    return hr + ':' + timeArr[1] + ' ' + postFix;
};

const convertTo12HrFormat = hour => {
    return Number(hour) > 12 ? '0' + (Number(hour) - 12) : hour;
};
*/

export const getTimeDifferenceBetweenDates = (date1, date2) => {
    return Math.abs((date1.getTime() - date2.getTime()) / 1000);
};

export const convertSecondsToHMS = (seconds) => {
    if (seconds == 0) {
        return '0s';
    }
    seconds = Math.ceil(seconds);

    var hours = Math.floor(seconds / 3600);
    seconds = seconds - hours * 3600;

    var minutes = Math.floor(seconds / 60);

    seconds = Math.ceil(seconds - minutes * 60);

    return `${hours > 0 ? `${hours}h ` : ''}${
        minutes > 0 ? `${minutes}m ` : ''
    }${seconds > 0 ? `${seconds}s` : ''}`;
};

export const convertMonthName = (month) => {
    return monthArr[month];
};

export const getDateFromString = (dateString) => {
    let date = new Date(dateString);
    if (date == 'Invalid Date') {
        return dateString;
    }
    return `${getMonth(date)}/${getDate(date)}/${date.getFullYear()}`;
};

export const getDateAndFromString = (dateString) => {
    let date = new Date(dateString);
    if (date == 'Invalid Date') {
        return dateString;
    }
    return `${getMonth(date)}/${getDate(
        date
    )}/${date.getFullYear()} ${date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    })}`;
};

export const getEndDateForMonths = (months) => {
    var currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() + months);
    return currentDate.toISOString();
};

export function getNumberOfDaysBetweenDates(date1, date2) {
    const diffTime = date2 - date1;
    return Math.ceil(-diffTime / (1000 * 60 * 60 * 24));
}

export const getDateFromStringInSlashFormat = (dateString) => {
    let date = new Date(dateString);
    if (date == 'Invalid Date') {
        return dateString;
    }
    return `${getMonth(date)}/${getDate(date)}/${date.getFullYear()}`;
};

/**
 * Function to retuen date and time in slash format
 * @param - dateString -
 */
export const getDateTimeFromStringInSlashFormat = (dateString) => {
    var date = new Date(dateString);
    if (date == 'Invalid Date') {
        return dateString;
    }

    let sHour = date.getHours();
    let sMinute = padValue(date.getMinutes());
    let sAMPM = 'AM';

    let iHourCheck = parseInt(sHour);

    if (iHourCheck > 12) {
        sAMPM = 'PM';
        sHour = iHourCheck - 12;
    } else if (iHourCheck === 0) {
        sHour = '12';
    }

    sHour = padValue(sHour);

    return getDateFromString(date) + ' ' + sHour + ':' + sMinute + ' ' + sAMPM;
};

const padValue = (value) => {
    return value < 10 ? '0' + value : value;
};

/**
 * Function to to convert the date in space format
 *
 * @param -date
 */
export const getDateInSpaceFormat = (date) => {
    const dateTimeArr = date.split('T');
    const dateArr = dateTimeArr[0].split('-');
    return dateArr[2] + ' ' + getMonthsName(date) + ' ' + dateArr[0];
};

/**
 * Function to to convert the date in Monthly format
 *
 * @param -date
 */

export const getMonthsName = (date) => {
    const d = new Date(date);
    const m = d.getMonth();
    return convertMonthName(Number(m));
};

/**
 * Function to return the date in MM/dd/yyyy format
 *
 * @param - toBeSubstractedDate // Date in string
 * @param - noOfDaysToBeSubstracted // Days in number
 */
export const substractDaysFromDate = (
    toBeSubstractedDate,
    noOfDaysToBeSubstracted
) => {
    var date = new Date(toBeSubstractedDate);
    var substractedDate = date.setDate(
        date.getDate() - noOfDaysToBeSubstracted
    );
    return format(new Date(substractedDate), 'MM/dd/yyyy');
};

/**
 * Function to convert and return date and time to UTC
 *
 * @param - date // Date in string
 * @param - time // Time in string
 */
export const convertDateAndTimeToUTC = (date, time) => {
    let formatDateAndTime = `${date} ${time}`;
    let getDate = moment(formatDateAndTime, 'MM/DD/YYYY h:mm a').toDate();
    return new Date(getDate).toISOString();
};

/**
 * Function to convert and return UTC to local
 *
 * @param - date // UTC Date in string
 */
export const convertUTCToLocalDateAndTime = (date) => {
    return moment(new Date(date)).format('MM/DD/YYYY h:mm A');
};

/**
 * Function to check if an expiration date is past the current date.
 * Returns true if the expirationDate is before today (i.e. expired),
 * or if the date is missing/invalid.
 *
 * @param {string} expirationDate - ISO date string (e.g. "2024-12-31T00:00:00Z")
 * @returns {boolean} - true if expired or invalid, false if still valid (future date)
 */
export const isExpirationDatePast = (expirationDate) => {
    if (!expirationDate) return true;
    const expDate = new Date(expirationDate);
    if (isNaN(expDate.getTime())) return true;
    return expDate < new Date();
};

/**
 * Function to create time array
 *
 */
export const getTimeArray = () => {
    const hours = [];
    for (let hour = 0; hour < 24; hour++) {
        hours.push(moment({ hour }).format('h:mm A'));
        hours.push(
            moment({
                hour,
                minute: 30
            }).format('h:mm A')
        );
    }
    return hours;
};
